"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPastSchoolYear = void 0;
function setPastSchoolYear(headers, callback) {
    try {
        const pastSchoolYears = callback();
        if (pastSchoolYears && pastSchoolYears.length > 0) {
            return (headers = {
                ...headers,
                'past-school-year': pastSchoolYears.join(','),
            });
        }
        return headers;
    }
    catch (e) {
        return headers;
    }
}
exports.setPastSchoolYear = setPastSchoolYear;
//# sourceMappingURL=past-school-year.helper.js.map